import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button } from "@mui/material";
import { specifyTargetKey } from "./core";
import type { SpecifyControlBinding } from "./types";

export const SpecifyAnswerButtons = ({
  control,
}: {
  control?: SpecifyControlBinding;
}) =>
  control?.fields
    .filter((field) => field.target.kind === "option-answer" && field.selected)
    .map((field) => (
      <Button
        key={specifyTargetKey(field.target)}
        aria-label={`${field.value}: ${field.prompt}`}
        disabled={field.disabled}
        startIcon={<EditOutlinedIcon />}
        onClick={() => control.open(field.target)}
        sx={{ textTransform: "none" }}
      >
        {field.value}
      </Button>
    ));
